import { isEqual, omit } from 'lodash';
import {
  ProjectDayTimeTracked,
  ProjectTimeEntry,
} from '../../../Projects/types';

export const isDirtyProjectEntries = (
  entries1: Array<ProjectDayTimeTracked | ProjectTimeEntry>,
  entries2: Array<ProjectDayTimeTracked | ProjectTimeEntry>,
): boolean => {
  if (entries1.length !== entries2.length) {
    return true;
  }

  if (entries1.length === 0) {
    return false;
  }

  const normalized1 = entries1.map((entry) =>
    omit(entry, ['timesheetId', 'date', 'dateId']),
  );
  const normalized2 = entries2.map((entry) =>
    omit(entry, ['timesheetId', 'date', 'dateId']),
  );

  return !isEqual(normalized1, normalized2);
};
